module.exports = __webpack_public_path__ + "img/wallet.661d818e.svg";